/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

// Header Section Data Sets
const lastScrollTop = 0,
	delta = 15,
	headerSection = jQuery( '.header-section' ),
	heroFixedVavCtn = jQuery( '.hero-fixed-nav-ctn' ),
	topBar = jQuery( '.top-bar' ),
	navOverlay = jQuery( '.nav-overlay' ),
	body_header = jQuery( 'header,body' )
	;

jQuery.noConflict();

adjustHeader();

// Function to handle load event
function handleLoad() {
	adjustTopBar();
}

// Function to handle resize event
function handleResize() {
	// Check if top bar is hidden, if it is, do not show it on resize
	if ( ! jQuery( '.top-bar' ).hasClass( 'hide-top-bar' ) ) {
		adjustTopBar();
	}
}

// Function to handle click event on top bar cross
function handleTopBarCrossClick() {
	hideTopBar();
}

// Function to adjust top bar
function adjustTopBar() {
	// Your existing code to adjust top bar goes here
}

// Function to show top bar
function adjustHeader() {
	const $topBar = jQuery( '.top-bar' );
	const $headerSection = jQuery( '.header-section' );
	const $headerInner = jQuery( '.header-inner' );

	// $headerSection.css( 'top', '0' );
	// jQuery( '.hero-section' ).css( 'padding-top', $headerSection.outerHeight() + 'px' );
}

// Function to hide top bar
function hideTopBar() {
	const $topBar = jQuery( '.top-bar' );
	const $headerSection = jQuery( '.header-section' );
	const $topBarCross = jQuery( '.top-bar-cross' );

	$topBar.addClass( 'hide-top-bar' );
	$headerSection.css( 'top', '-' + $topBar.outerHeight() + 'px' );
	// jQuery( '.hero-section' ).css( 'padding-top', $headerSection.outerHeight() - $topBar.outerHeight() + 'px' );
}

// Bind load event handler
jQuery( window ).on( 'load', handleLoad );

// Bind resize event handler
jQuery( window ).on( 'resize', handleResize );

// Bind click event handler for top bar cross
jQuery( '.top-bar-cross' ).on( 'click', handleTopBarCrossClick );

jQuery( function() {
	const owl = jQuery( '.image-slider' );
	owl.owlCarousel( {
	  items: 1,
	  loop: true,
	  nav: true,
	  dots: true,
	  autoplay: true,
	  autoplayTimeout: 6000,
	  autoplayHoverPause: true,
	  smartSpeed: 1500,
	  animateOut: 'fadeOut',
	  animateIn: 'fadeIn',
	  mouseDrag: true,
	  touchDrag: true,
	  responsive: {
			0: {
				nav: false,
		  },
			1024: {
		  nav: true,
			},
	  },
	} );

	const sliderCtn = jQuery( '.slider-ctn' );
	sliderCtn.owlCarousel( {
		items: 4,
		margin: 24,
		dots: false,
		nav: true,
		loop: true,
		autoplay: true,
		autoplayTimeout: 2000,
		autoplayHoverPause: true,
		animateIn: 'fadeIn',
		animateOut: 'fadeOut',
		responsive: {
			1024: {
				items: 3,
			   },
			1380: {
				margin: 20,
				items: 3,
			},
			1440: {
				margin: 24,
				items: 4,
			},
		  },
	} );

	const sliderArticleCtn = jQuery( '.slider-article-ctn' );
	sliderArticleCtn.owlCarousel( {
		items: 3,
		margin: 24,
		dots: false,
		nav: true,
		loop: true,
		autoplay: true,
		autoplayTimeout: 2000,
		autoplayHoverPause: true,
		animateIn: 'fadeIn',
		animateOut: 'fadeOut',
	} );

	const bookSlider = jQuery( '.book-slider' );
	bookSlider.owlCarousel( {
		items: 5,
		dots: false,
		nav: true,
		loop: true,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		margin: 20,
	} );

	// Resources section tabs
	jQuery( document ).ready( function() {
		// Hide all tabs except the first one on page load
		jQuery( '.tab-content' ).hide();
		jQuery( '.tab-content' ).first().show();

		// Tab click functionality
		jQuery( '.tab-content-links' ).on( 'click', 'a', function( e ) {
			e.preventDefault();

			jQuery( '.tab-content-links a' ).removeClass( 'current' );
			jQuery( this ).addClass( 'current' );

			const tabId = jQuery( this ).data( 'tab' );

			jQuery( '.tab-content' ).hide();
			jQuery( '#' + tabId ).show();
		} );
	} );

	/**
	 * Toggle menu for mobile
	 */
	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	jQuery( '.menu-btn,.menu-cross-icon' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		navOverlay.toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	const $wrapper = jQuery( '.search-bar-form' );
	const $form = $wrapper.find( 'form' );

	jQuery( '.search-icon' ).on( 'click', () => $wrapper.toggleClass( 'active' ) );
	jQuery( '.search-bar .close-icon' ).on( 'click', () => $wrapper.removeClass( 'active' ) );

	jQuery( document ).on( 'click', ( e ) => {
	  const $t = jQuery( e.target );
	  if (
			$wrapper.hasClass( 'active' ) &&
		! $form.is( $t ) &&
		! $form.has( $t ).length &&
		! $t.closest( '.search-icon' ).length
	  ) {
			$wrapper.removeClass( 'active' );
	  }
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );
	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */
	jQuery( document ).on( 'click', '.header-nav .menu-item span', function() {
		const link = jQuery( this ).parents( 'li' );

		link.siblings( '.active' ).removeClass( 'active' ).find( 'ul' ).slideUp();

		if ( link.hasClass( 'active' ) ) {
			link.removeClass( 'active' );
			link.parents( 'ul' ).removeClass( 'disabled-menu' );
			link.find( 'ul' ).slideUp();
		} else {
			link.addClass( 'active' );
			link.parents( 'ul' ).addClass( 'disabled-menu' );
			link.find( 'ul' ).slideDown();
		}
	} );
	jQuery( '.popup-video-link' ).magnificPopup( {
		type: 'iframe',
	} );

	jQuery( '.faq-head' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).siblings( '.faq-content' ).slideUp( 300 );
		} else {
			jQuery( '.faq-head' ).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
			jQuery( '.faq-content' ).slideUp( 300 );

			jQuery( this ).addClass( 'active' );
			jQuery( this ).siblings( '.faq-content' ).slideDown( 300 );
		}
	} );
	if ( jQuery( window ).width() < 767 ) {
		jQuery( '.video-playlist-head' ).on( 'click', function() {
			if ( jQuery( this ).hasClass( 'active' ) ) {
				jQuery( this ).removeClass( 'active' );
				jQuery( this ).siblings( '.video-playlist' ).slideUp( 300 );
			} else {
				jQuery( '.video-playlist-head' ).removeClass( 'active' );
				jQuery( this ).addClass( 'active' );
				jQuery( '.video-playlist' ).slideUp( 300 );

				jQuery( this ).addClass( 'active' );
				jQuery( this ).siblings( '.video-playlist' ).slideDown( 300 );
			}
		} );
	}
} );

// Articles Filter

jQuery( document ).ready( function() {
	jQuery( '#select-topics' ).change( function() {
		const selected = jQuery( this ).val();

		if ( selected === 'topics' ) {
			// If 'Topics' is selected, reset and fetch all posts
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_articles',
					category: '', // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#articles-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#articles-container' ).html( htmlTag );
				},
			} );
		} else {
			// If a specific category is selected, fetch posts for that category
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_articles',
					category: selected,
				},
				success( response ) {
					jQuery( '#articles-container' ).html( response );
				},
				error() {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#articles-container' ).html( htmlTag );
				},
			} );
		}
	} );
} );

// Books Filter

jQuery( document ).ready( function() {
	jQuery( '#select-book-topics' ).change( function() {
		const selected = jQuery( this ).val();

		if ( selected === 'topics' ) {
			// If 'Topics' is selected, reset and fetch all posts
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_books',
					category: '', // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#books-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#books-container' ).html( htmlTag );
				},
			} );
		} else {
			// If a specific category is selected, fetch posts for that category
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_books',
					category: selected,
				},
				success( response ) {
					jQuery( '#books-container' ).html( response );
				},
				error() {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#books-container' ).html( htmlTag );
				},
			} );
		}
	} );
} );

// Pamphlets Filter

jQuery( document ).ready( function() {
	jQuery( '#select-pamphlet-topics' ).change( function() {
		const selected = jQuery( this ).val();

		if ( selected === 'topics' ) {
			// If 'Topics' is selected, reset and fetch all posts
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_pamphlets',
					category: '', // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#pamphlet-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#pamphlet-container' ).html( htmlTag );
				},
			} );
		} else {
			// If a specific category is selected, fetch posts for that category
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_pamphlets',
					category: selected,
				},
				success( response ) {
					jQuery( '#pamphlet-container' ).html( response );
				},
				error() {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#pamphlet-container' ).html( htmlTag );
				},
			} );
		}
	} );
} );
// Magzines Filter

jQuery( document ).ready( function() {
	jQuery( '#select-magzine-topics' ).change( function() {
		const selected = jQuery( this ).val();

		if ( selected === 'topics' ) {
			// If 'Topics' is selected, reset and fetch all posts
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_magzines',
					category: '', // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#magzine-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#magzine-container' ).html( htmlTag );
				},
			} );
		} else {
			// If a specific category is selected, fetch posts for that category
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_magzines',
					category: selected,
				},
				success( response ) {
					jQuery( '#magzine-container' ).html( response );
				},
				error() {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#magzine-container' ).html( htmlTag );
				},
			} );
		}
	} );
} );

// Events Filter

jQuery( document ).ready( function() {
	jQuery( '#select-event-type' ).change( function() {
		const selected = jQuery( this ).val();
		if ( selected === 'type' ) {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_events',
					category: '', // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#events-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#events-container' ).html( htmlTag );
				},
			} );
		} else {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_events',
					category: selected, // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#events-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#events-container' ).html( htmlTag );
				},
			} );
		}
	} );
} );

// Blog Filter

jQuery( document ).ready( function() {
	jQuery( '#select-category-type' ).change( function() {
		const selected = jQuery( this ).val();
		if ( selected === 'select-post' ) {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_blogs',
					category: '', // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#posts-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#posts-container' ).html( htmlTag );
				},
			} );
		} else {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_blogs',
					category: selected, // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#posts-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#posts-container' ).html( htmlTag );
				},
			} );
		}
	} );
} );

// Audio Filter

jQuery( document ).ready( function() {
	jQuery( '#select-audio' ).change( function() {
		const selected = jQuery( this ).val();
		if ( selected === 'audio-topics' ) {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_audios',
					category: '', // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#audios-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#audios-container' ).html( htmlTag );
				},
			} );
		} else {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_audios',
					category: selected, // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#audios-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#audios-container' ).html( htmlTag );
				},
			} );
		}
	} );
} );

// City Filter

jQuery( document ).ready( function() {
	jQuery( '#select-cities' ).change( function() {
		const selected = jQuery( this ).val();
		if ( selected === 'city-selection' ) {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_cities',
					category: '', // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#cities-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#cities-container' ).html( htmlTag );
				},
			} );
		} else {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_cities',
					category: selected, // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#cities-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#cities-container' ).html( htmlTag );
				},
			} );
		}
	} );
} );

jQuery( document ).ready( function() {
	function filterCourses( type ) {
		const currentDate = new Date();

		let coursesFound = false;

		jQuery( '.course' ).each( function() {
			const startDateAttr = jQuery( this ).data( 'start-date' );

			if ( ! startDateAttr ) {
				return;
			}

			const startDate = new Date( startDateAttr );

			if ( isNaN( startDate ) ) {
				return;
			}

			const diffDays = Math.ceil( ( currentDate - startDate ) / ( 1000 * 60 * 60 * 24 ) );

			if ( type === 'current' ) {
				if ( diffDays >= 0 && diffDays <= 4 ) {
					jQuery( this ).show();
					coursesFound = true;
				} else {
					jQuery( this ).hide();
				}
			} else if ( type === 'upcoming' ) {
				const currentDateOnly = new Date( currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() );
				const startDateOnly = new Date( startDate.getFullYear(), startDate.getMonth(), startDate.getDate() );

				if ( startDateOnly > currentDateOnly ) {
					jQuery( this ).show();
					coursesFound = true;
				} else {
					jQuery( this ).hide();
				}
			}
		} );
		if ( ! coursesFound ) {
			jQuery( '.no-courses-message' ).show();
		} else {
			jQuery( '.no-courses-message' ).hide();
		}
	}

	jQuery( '.current-courses' ).on( 'click', function( e ) {
		e.preventDefault();
		jQuery( '.category-links a' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
		filterCourses( 'current' );
	} );

	jQuery( '.upcoming-courses' ).on( 'click', function( e ) {
		e.preventDefault();
		jQuery( '.category-links a' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
		filterCourses( 'upcoming' );
	} );
	filterCourses( 'current' );
} );

jQuery( document ).ready( function( ) {
	jQuery( '.single-video' ).on( 'click', function() {
		const newSrc = jQuery( this ).data( 'video-src' );
		jQuery( '#main-video-frame' ).attr( 'src', newSrc );
	} );
} );

jQuery( document ).ready( function() {
	jQuery( '.bookmark-video' ).on( 'click', function( e ) {
		e.preventDefault();
		const videoUrl = jQuery( '#main-video-frame' ).attr( 'src' );
		let bookmarks = JSON.parse( localStorage.getItem( 'bookmarkedVideos' ) ) || [];

		if ( bookmarks.includes( videoUrl ) ) {
			bookmarks = bookmarks.filter( function( url ) {
				return url !== videoUrl;
			} );
			alert( 'Removed from bookmarks' );
			jQuery( this ).removeClass( 'bookmarked' );
		} else {
			bookmarks.push( videoUrl );
			alert( 'Video bookmarked' );
			jQuery( this ).addClass( 'bookmarked' );
		}

		localStorage.setItem( 'bookmarkedVideos', JSON.stringify( bookmarks ) );
	} );
	jQuery( '.share-now' ).on( 'click', function( e ) {
		e.preventDefault();
		jQuery( '.social-share-icons' ).slideToggle();
	} );
} );

// Video Filter

jQuery( document ).ready( function() {
	jQuery( '#select-video-topics' ).change( function() {
		const selected = jQuery( this ).val();
		if ( selected === 'video-topics' ) {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_videos',
					category: '', // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#videos-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#videos-container' ).html( htmlTag );
				},
			} );
		} else {
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'POST',
				data: {
					action: 'filter_videos',
					category: selected, // Empty category value to fetch all posts
				},
				success( response ) {
					jQuery( '#videos-container' ).html( response );
				},
				error( ) {
					const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>" );
					jQuery( '#videos-container' ).html( htmlTag );
				},
			} );
		}
	} );
} );
jQuery( document ).ready( function( jQuery ) {
	// Scroll to top on click
	jQuery( '.scroll-top' ).on( 'click', function() {
		jQuery( 'html, body' ).animate( { scrollTop: 0 }, 600 );
	} );

	// Show/hide the button when scrolling
	jQuery( window ).on( 'scroll', function() {
		if ( jQuery( this ).scrollTop() > 200 ) {
			jQuery( '.scroll-top' ).fadeIn();
		} else {
			jQuery( '.scroll-top' ).fadeOut();
		}
	} );

	// Initial state
	jQuery( '.scroll-top' ).hide();

	const $popup = jQuery( '.newsletter-box' );

	// Replace with actual login check
	const isLoggedIn = window.isUserLoggedIn || false;

	// Check stored values
	const hasSubscribed = localStorage.getItem( 'newsletter_subscribed' ) === 'true';
	const closedThisSession = sessionStorage.getItem( 'newsletter_closed' ) === 'true';

	// Show only if: not logged in, not subscribed, and not closed in this session
	if ( ! isLoggedIn && ! hasSubscribed && ! closedThisSession ) {
		setTimeout( () => $popup.addClass( 'show' ), 3000 );
	}

	// Close = hide temporarily for session only
	$popup.on( 'click', '.close-icon', () => {
		$popup.removeClass( 'show' );
		sessionStorage.setItem( 'newsletter_closed', 'true' ); // Hide only this session
	} );

	// Submit = hide permanently
	$popup.on( 'submit', 'form', function( e ) {
		e.preventDefault();
		alert( 'Thank you for subscribing!' );
		$popup.removeClass( 'show' );
		localStorage.setItem( 'newsletter_subscribed', 'true' ); // Never show again
	} );

	jQuery( '.lang-dropdown-toggle' ).on( 'click', function( e ) {
		e.stopPropagation();
		jQuery( '#langMenu' ).slideToggle( 200 );
	  } );

	  jQuery( document ).on( 'click', function() {
		jQuery( '#langMenu' ).slideUp( 200 );
	} );

	// const langClassMap = {
	// 	'en-US': 'english-language',
	// 	'ur': 'urdu-language',
	// 	'ar': 'arabic-language'
	//   };

	//   // Get lang from <html lang="...">
	//   const htmlLang = jQuery('html').attr('lang');

	//   // Get the correct class from map
	//   const langClass = langClassMap[htmlLang] || '';

	//   // Optional: remove all previous lang classes
	//   const allLangClasses = Object.values(langClassMap);
	//   jQuery('body').removeClass(allLangClasses.join(' '));

	//   // Add class to body
	//   if (langClass) {
	// 	jQuery('body').addClass(langClass);
	//   }

	  const langMap = { 'english-language': 'en-TN-u-ca-islamic', 'urdu-language': 'ur-TN-u-ca-islamic', 'arabic-language': 'ar-TN-u-ca-islamic' };
	  const bodyClass = Object.keys( langMap ).find( ( cls ) => jQuery( 'body' ).hasClass( cls ) ) || 'english-language';
	  const formatter = new Intl.DateTimeFormat( langMap[ bodyClass ], { day: 'numeric', month: 'long', year: 'numeric' } );
	  jQuery( '.Islamic-date' ).text( formatter.format( new Date() ) );

	//   function updateCopyright() {
	//     if (jQuery("body").hasClass("urdu-language")) {
	//       jQuery(".copyright").html(
	//         '<span>کاپی رائٹ © 2025</span> <a href="https://khatmenubuwwat.net/تعارف" target="_blank" rel="noopener"><span>عالمی مجلس تحفظ ختم نبوت</span></a>. تمام حقوق محفوظ ہیں۔'
	//       );
	//     } else {
	//       jQuery(".copyright").html(
	//         'Copyright © by <a href="https://khatmenubuwwat.net/about" target="_blank" rel="noopener">Aalmi Majlis Tahaffuz Khatm-e-Nubuwwat</a>. All rights reserved.'
	//       );
	//     }
	//   }

	// //   // ==========================
	// //   // 2) Update Address
	// //   // ==========================
	// //   var addressElement = jQuery(".site-address address");
	// //   var texts = {
	// //     en: "Head Office : Aalmi Majlis Tahaffuz Khatm-e-nubuwwat ; Hazuri Bagh Road Multan.",
	// //     ur: "ہیڈ آفس : عالمی مجلس تحفظ ختم نبوت ؛ حضوری باغ روڈ ملتان۔",
	// //   };

	//   function updateAddress() {
	//     if (jQuery("body").hasClass("urdu-language")) {
	//       addressElement.text(texts.ur);
	//     } else if (jQuery("body").hasClass("english-language")) {
	//       addressElement.text(texts.en);
	//     }
	//   }

	//   // ==========================
	//   // 3) Run All Updaters Together
	//   // ==========================
	//   function runAllUpdates() {
	//     updateCopyright();
	//     updateAddress();
	//     // 👉 Future new functions (like updateMenu, updateFooterTitle) بس یہاں call add کریں
	//   }

	//   // Run once on page load
	//   runAllUpdates();

//   // ==========================
//   // 4) Single Observer (no duplicates)
//   // ==========================
//   const target = document.body;
//   const observer = new MutationObserver(runAllUpdates);
//   observer.observe(target, { attributes: true, attributeFilter: ["class"] });
} );
